import { render, staticRenderFns } from "./collectTaskRecords.vue?vue&type=template&id=9975142a"
import script from "./collectTaskRecords.vue?vue&type=script&lang=js"
export * from "./collectTaskRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports